import { Button, Grid2} from '@mui/material';
import Layout from './Layout';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { TextFormField } from '../../shared/components/FormFields/TextFormField';
import { useMutation } from '@tanstack/react-query';
import { useToaster } from '../../shared/utils/ToasterProvider';
import useResponsive from '../../shared/utils/Responsive';
import SmLayout from './SmLayout';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../assets/nodeApi/axiosInstance';

const ResetPassword = () => {
    const navigate = useNavigate()
    const isSmallScreen = useResponsive("md")
    const { token, phone,role } = useParams();
    const { showToaster } = useToaster();
    const sendOtpMutation = useMutation({
        mutationFn: (formData) => api.post("reset-password", formData),
    });

    const handleSubmit = (values) => {
        const obj = {
            mobile: phone,
            token: token,
            device: "web",
            role:role,

            ...values
        }
        sendOtpMutation.mutate(obj, {
            onSuccess: (response) => {
                navigate("/SelectLoginPath");

            },
            onError: (error) => {
                showToaster('Error', error?.response?.data?.message, 'error')
            },
        });
    };


    const ResetpasswordForm = () => (
        <Formik
            initialValues={{ password: "", password_confirmation: "" }}
            validationSchema={yup.object().shape({
                password: yup
                    .string()
                    .min(8, "Password must be at least 8 characters")
                    .required("Password is required"),

                password_confirmation: yup
                    .string()
                    .oneOf([yup.ref("password"), null], "Passwords must match")
                    .required("Confirm Password is required"),
            })}
            onSubmit={handleSubmit}  >
            {() => (
                <Form>
                    <Grid2 container spacing={3}>

                        <Grid2 children size={12}>
                            <Field
                                name="password"
                                component={TextFormField}
                                label="Password"
                                isRequired={true}
                                type={"password"}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="password_confirmation"
                                component={TextFormField}
                                label="Confirm Password"
                                isRequired={true}
                                type={"password"}
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <Button variant='contained' fullWidth type="submit">Reset</Button>
                        </Grid2>

                    </Grid2>
                </Form>
            )}
        </Formik>
    )
    return (
        <>
            {!isSmallScreen && <Layout
                title={"Set New Password"}
                text={"Create a strong password and keep your account safe and secure"}
            >
                {ResetpasswordForm()}
            </Layout>}

            {
                isSmallScreen && <SmLayout
                    title={"Set New Password"}
                    text={"Create a strong password and keep your account safe and secure"}
                >
                    {ResetpasswordForm()}
                </SmLayout>
            }

        </>
    )
}

export default ResetPassword